export class HeaderBannerController {
    constructor() {
        this.init();
    }

    init() {
        const closeButton = document.querySelector('.header-banner__close');
        if (closeButton && closeButton.closest('.header-banner')) {
            closeButton.addEventListener('click', () => {
                const headerBanner = closeButton.closest('.header-banner');
                if (headerBanner) {
                    headerBanner.classList.add('hidden');
                }
            });
        }
    }
}